export default "<nb-icon class=\"icon\" [ngClass]=\"{'animate' : this.animate}\" [icon]=\"this.animate ? this.endIcon : this.startIcon\">\n</nb-icon>\n"